import { CustomLabelPrinterType, ItemCustomLabel } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';

export type { CustomLabelPrinterType, ItemCustomLabel } from '@conveyr/shared-types';

// The published OpenAPI bundle does not yet document custom labels.
export interface ItemCustomLabelRaw {
    name: string
    url: string
    printer_type: CustomLabelPrinterType
}

export function toCustomLabel(label: { name: string; url: string; printer_type: string }): ItemCustomLabel {
    const printerType = label.printer_type;
    if (printerType !== 'barcode' && printerType !== 'shipping' && printerType !== 'paper') {
        throw new Error(`Unsupported custom label printer type: ${printerType}`);
    }
    return { name: label.name, url: label.url, printerType };
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): {
    create: (itemId: number | string, printerType: CustomLabelPrinterType, attachmentUploadUuid: string) => Promise<ItemCustomLabel>
    remove: (itemId: number | string) => Promise<void>
} => ({
    create: async (itemId: number | string, printerType: CustomLabelPrinterType, attachmentUploadUuid: string): Promise<ItemCustomLabel> => {
        const response = await axios.post<{ data: ItemCustomLabelRaw }>(`/api/inventory/${itemId}/custom-label`, {
            printer_type: printerType,
            attachment_upload_uuid: attachmentUploadUuid,
        });
        return toCustomLabel(response.data.data);
    },
    remove: async (itemId: number | string): Promise<void> => {
        await axios.delete(`/api/inventory/${itemId}/custom-label`);
    },
});
